import styled from "styled-components";
import { Box } from "../Box";

export const Flex: any = styled(Box)`
  display: flex;
`;

export const FlexVertical: any = styled(Flex)`
  flex-direction: column;
`;
